import { useContext } from "react";
import UserDateTimeContext from "contexts/UserDateTimeContext";
const useUserDateTime = () => {
  const userDateTime = useContext(UserDateTimeContext);
  if (!userDateTime) {
    throw new Error("useUserDateTime hook needs to be used inside UserDateTimeContext.Provider");
  }
  return userDateTime;
};
export default useUserDateTime;
